
import { Canvas } from '@react-three/fiber'
import { Box, Cylinder, Gltf, OrbitControls, Plane, Sphere, useAnimations, useGLTF } from '@react-three/drei';
import { Suspense, useState } from "react";
import { CuboidCollider, Physics, RigidBody } from '@react-three/rapier';

import { BrowserRouter as Router } from 'react-router-dom';
import { Experience } from './GameComponents/Experience';


function App() {

  return (
    <Router>
      <div style={{ width: "100vw", height: "100vh" }}>
        <Canvas shadows camera={{ position: [0, 6, 14], fov: 42 }}>
          <OrbitControls />
          <axesHelper />
          <gridHelper />
          <color attach="background" args={["#000000"]} />
          <directionalLight intensity={1} shadow-bias={-0.0004} position={[-20, 20, 20]}>
            <orthographicCamera attach="shadow-camera" args={[-20, 20, 20, -20]} />
          </directionalLight>
          <ambientLight intensity={0.2} />
          <Suspense>
            <Physics  >
              <Experience />
            </Physics>
          </Suspense>
        </Canvas>

      </div >
    </Router>
  );
}

export default App;